import { createClient } from "@supabase/supabase-js";

const supabaseUrl = 'https://xabwcwhoywjuzleozjym.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhhYndjd2hveXdqdXpsZW96anltIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU0ODE5NjYsImV4cCI6MjA3MTA1Nzk2Nn0.jVU9OSY12HVAwbEZnj3b303PE1q7lZRyguClbB-8V4Y';
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;


